module.exports = __webpack_public_path__ + "media/icons/data-picker@3x-86b4cc88.svg";